export default {
    "de": {
        "common": {
            "types": {
                "assembling": "Montage",
                "servicing": "Serviceauftrag"
            },
            "parts": {
                "types": {
                    "door": "Element"
                },
                "categories": {
                    "door": {
                        "common": "Element|Elemente"
                    }
                },
                "areas": {
                    "door": {
                        "undefined": "Bitte wählen",
                        "frame": "Türrahmen",
                        "leaf": "Türblatt",
                        "hinges": "Bänder",
                        "closing": "Schliesssystem",
                        "handle": "Türdrücker",
                        "electrics": "Elektronik",
                        "fire_protection": "Brandschutzelemente",
                        "allgemein": "Allgemein",
                    }
                }
            },
            "rating": {
                "rating_keywords": {
                    "1": "Sehr schlecht",
                    "2": "Schlecht",
                    "3": "OK",
                    "4": "Gut",
                    "5": "Super"
                }
            }
        },
        "windows": {
            "edit-date": {
                "common": {
                    "headings": {
                        "type": "Terminart wählen",
                        "dates": "Zeitpunkt wählen",
                        "dates_span": "Zeitfenster wählen"
                    },
                    "labels": {
                        "duration": "Minuten",
                        "date_start": "Datum Beginn",
                        "date_end": "Datum Ende",
                        "time_start": "Zeit Beginn",
                        "time_end": "Zeit Ende"
                    }
                },
                "assembling": {
                    "title": "Montagetermin planen",
                    "headings": {
                        "duration": "Dauer der Montage im Zeitfenster"
                    }
                },
                "servicing": {
                    "title": "Servicetermin planen",
                    "headings": {
                        "duration": "Dauer der Servicearbeiten im Zeitfenster"
                    }
                }
            },
            "edit-checks": {
                "title": "Checks für einen Türtyp bearbeiten"
            },
            "parts-status-list": {
                "title": "Status Bauteile",
                "phrases": {
                    "finished": "Abgeschlossen {finished} von {all}"
                }
            },
            "technician-requests": {
                "title": "Monteur auswählen:"
            },
            "rating": {
                "common": {
                    "title": "Bewertung",
                    "subtitle": {
                        "technician": "Wie zufrieden waren Sie mit der Bau-Organisation?"
                    },
                    "labels": {
                        "message": "Zusätzliche Informationen"
                    },
                    "placeholder": {
                        "message": {
                            "manager": "Schreiben Sie hier Informationen, welche für andere Projektleiter wertvoll sind"
                        }
                    }
                },
                "assembling": {
                    "subtitle": {
                        "manager": "Bewerten Sie die ausgeführte Montage und den Monteur"
                    }
                },
                "servicing": {
                    "subtitle": {
                        "manager": "Bewerten Sie den ausgeführten Serviceauftrag und den Monteur"
                    }
                }
            },
            "checklist": {
                'header': 'Checklisten',

                'labels': {
                    'name': 'Name',
                    'part_type': 'Türtyp',
                    'part_area': 'Bereich',
                    'useable_for': 'Verwendbar für',
                    'for': {
                        'assembling': 'Montagen',
                        'servicing': 'Servicetätigkeiten'
                    },
                    'parts': 'Bereiche',
                    'check': {
                        'title': 'Titel',
                        'description': 'Beschreibung',
                        'operations': 'Tätigkeiten'
                    }
                },

                'buttons': {
                    'add_checklist': 'Neue Checkliste',
                    'add_part': 'Bereich hinzufügen',
                    'add_check': 'Check hinzufügen'
                },

                'windows': {
                    'checks': {
                        'title': 'Checks für einen Türbereich bearbeiten'
                    },
                    'addchecks': {
                        'title': 'Neue Checklisten anlegen'
                    }
                }
            }
        },
        "components": {
            "controls": {
                "common": {
                    "sort": "Sortieren nach:",
                    "filter": {
                        "all": "Alle",
                        "open": "Monteur zuweisen",
                        "planned": "Geplant",
                        "inprocess": "In Ausführung",
                        "cancelled": "Abgebrochen",
                        "finished": "Abgeschlossen"
                    },
                    "sort_by": {
                        "project_nr": "Projektnummer",
                        "planned": "Kalenderwoche",
                        "date": "Datum"
                    }
                },
                "assembling": {
                    "search": "Suche nach Montage",
                    "toggle_my": "Meine Montagen",
                    "filter": {
                        "new": "Montage erstellen"
                    }
                },
                "servicing": {
                    "search": "Suche nach Service",
                    "toggle_my": "Meine Service",
                    "filter": {
                        "new": "Service erstellen"
                    }
                }
            },
            "list": {
                "common": {
                    "headings": {
                        "job_id": "Projekt",
                        "job_name": "Projekt Name",
                        "technician": "Monteure",
                        "status": "Status"
                    },
                    "buttons": {
                        "inquiry": "Monteur zuordnen",
                        "inquired": "Angefragt",
                        "planned": "Geplant",
                        "rate": "Jetzt bewerten",
                        "finished": "Abgeschlossen",
                        "unfinished": "Unvollständig abgeschlossen",
                        "cancelled": "Abgebrochen",
                        "recreate": "Neu erstellen",
                        "show_cancel_message": "Abbruch-Meldung anzeigen"
                    }
                },
                "assembling": {
                    "headings": {
                        "date": "Montagetermine"
                    },
                    "buttons": {
                        "create": "Montage erstellen"
                    }
                },
                "servicing": {
                    "headings": {
                        "date": "Servicetermine"
                    },
                    "buttons": {
                        "create": "Service erstellen"
                    }
                }
            },
            "parts": {
                "status_list": {
                    "header": {
                        "type": "Typ",
                        "pos": "Position",
                        "status": "Status"
                    }
                }
            },
            "dates": {
                "types": {
                    "labels": {
                        "fixed": "Fixtermin",
                        "shiftable": "Schiebbar",
                        "span": "Zeitfenster"
                    },
                    "icons": {
                        "fixed": "lock",
                        "shiftable": "shiftable",
                        "span": "span"
                    }
                }
            },
            "fittings": {
                "list": {
                    "common": {
                        "fitting_unit_default": "Stück"
                    },
                    "header": {
                        "type": "Typ",
                        "amount": "Anzahl",
                        "unit": "Einheit",
                        "title": "Bezeichnung",
                        "status": "Kontrolle",
                        "message": "Meldung",
                        "docs": "Dateien",
                        "properties": "Eigenschaften"
                    },
                    "phrases": {
                        "no_docs": "Keine Dateien vorhanden.",
                        "no_properties": "Keine Eigenschaften angegeben."
                    }
                }
            },
            "rating": {
                "display": {
                    "labels": {
                        "keyword": "Bewertung:",
                        "message": "Anmerkungen:"
                    }
                }
            },
            "messages": {
                "common": {
                    "types": {
                        "0": "Nicht definiert",
                        "5": "Beschlägeliste",
                        "6": "Checks",
                        "7": "Reparaturanfragen"
                    }
                },
                "assembling": {
                    "types": {
                        "1": "Allgemein Montage",
                        "2": "Erstellung Montage",
                        "3": "Abschluss Montage",
                        "4": "Allgemeine Notiz Montage"
                    }
                },
                "servicing": {
                    "types": {
                        "1": "Allgemein Service",
                        "2": "Erstellung Service",
                        "3": "Abschluss Service",
                        "4": "Allgemeine Notiz Service"
                    }
                }
            },

        },
        "pages": {
            "show": {
                "common": {
                    "buttons": {
                        "parts_status_list": "Status-Liste Bauteile"
                    },
                    "tabs": {
                        "common": "Allgemeine Informationen",
                        "dates": "Terminplanung",
                        "checks_and_docs": "Planunterlagen und Checks",
                        "notifications": "Meldungen Montage"
                    }
                },
                "assembling": {
                    "notifications": {
                        "header": "Meldungen Montage",
                        "phrases": {
                            "no_notifications": "Aktuell keine Meldungen für diese Montage."
                        }
                    }
                },
                "servicing": {
                    "notifications": {
                        "header": "Meldungen Serviceauftrag",
                        "phrases": {
                            "no_notifications": "Aktuell keine Meldungen für diesen Serviceauftrag."
                        }
                    }
                }
            },
            "edit": {
                "common": {
                    "buttons": {
                        "next_step": "Weiter"
                    },
                    "tabs": {
                        "dates": {
                            "tab_name": "Termin Auswahl"
                        },
                        "common": {
                            "tab_name": "Allgemeine Infos",
                            "infos": {
                                "labels": {
                                    "fittings_locations": "Beschlägefachnummern"
                                },
                                "placeholders": {
                                    "fittings_locations": "zb. 53, 54, 55"
                                }
                            },
                            "contacts": {
                                "header": "Kontaktpersonen",
                                "labels": {
                                    "type": "Art des Kontakts",
                                    "tel": "Telefon",
                                    "name": "Name",
                                    "email": "E-Mail"
                                },
                                "buttons": {
                                    "add_contact": "Weiteren Kontakt erfassen"
                                }
                            },
                            "tools": {
                                "header": "Spezialwerkzeug"
                            },
                            "skills": {
                                "header": "Fähigkeitenprofil"
                            }
                        },
                        "checks": {
                            "tab_name": "Checks",
                            "parts": "Element | Elemente",
                            "buttons": {
                                "edit_all_checks": "Checks für alle {type} bearbeiten",
                                "edit_check": "Checks für {name} bearbeiten"
                            },
                            "headers": {
                                "part_checks": "Tür-Checks",
                                "part_docs": "Unterlagen"
                            },
                            "phrases": {
                                "no_docs": "Keine Unterlagen vorhanden.",
                                "no_checks_for_type": "Noch keine Checklisten für diesen Türtyp vorhanden."
                            }
                        },
                        "overview": {
                            "tab_name": "Übersicht"
                        }
                    }
                },
                "assembling": {
                    "buttons": {
                        "create": "Montage erstellen"
                    },
                    "tabs": {
                        "common": {
                            "infos": {
                                "labels": {
                                    "infos": "Allgemeine Infos zur Montage",
                                    "instruction": "Montageanleitung"
                                }
                            },
                            "locations": {
                                "header": "Adresse Montage"
                            }
                        }
                    }
                },
                "servicing": {
                    "buttons": {
                        "create": "Serviceauftrag erstellen"
                    },
                    "tabs": {
                        "common": {
                            "infos": {
                                "labels": {
                                    "infos": "Allgemeine Infos zum Serviceauftrag",
                                    "instruction": "Serviceanleitung"
                                }
                            },
                            "locations": {
                                "header": "Adresse Serviceauftrag"
                            }
                        }
                    }
                }
            }
        }
    }
}
